export default "__VITE_ASSET__di0XOXim__"